<div class="wrapper">

  <section id="banner-home" class="banner-container hero is-fullheight banner-landing"
    style="background-image:url(assets/img/bg-landing.jpg)">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-6">
            <img src="assets/img/black-days.png">
            <img src="assets/img/promocoes-diarias.png">
          </div>
          <div class="column is-6 area-indique">
            <h5>Indique quantos amigos quiser!</h5>
            <p class="descricao-indique">Preencha o formulário com os seus dados e os dos seus amigo. É bem rapidinho!</p>

            <div class="area-form">
              <form class="sample-form" method="post" action-xhr="/documentation/examples/api/phone" target="_top">
                <h4 id="indicar-amigos">Quer Indicar seus Amigos?</h4>
                <p>Comece a ganhar agora!</p>
                
                <div class="area-inputs">
                  <div class="field indique-amigos" tabindex="1">
                    <label for="nome">Seu nome</label>
                    <input name="nome" type="text" placeholder="Digite seu nome" required>
                  </div>

                  <div class="field indique-amigos" tabindex="1">
                    <input name="email" type="email" placeholder="E-mail" required>
                  </div>

                  <div class="field indique-amigos" tabindex="1">
                    <input name="celular" type="tel" mask="(99)9_9999-9999" placeholder="Celular" mask-output="alphanumeric"
                      required>
                  </div>

                  <div class="field indique-amigos" tabindex="1">
                    <input name="cpf" type="cpf" mask="000.000.000-00" placeholder="CPF" mask-output="alphanumeric" required>
                  </div>

                  <p><strong>Indicados</strong></p>


                  <div class="field indique-amigos" tabindex="1">
                    <input name="nome" type="text" placeholder="Nome do indicado" required>
                  </div>

                  <div class="field indique-amigos" tabindex="1">
                    <input name="nome" type="text" placeholder="Celular do indicado" required>
                  </div>

                  <p><span>+</span><small>Adicionar outro indicado</small></p>

                  <button class="btn-verde" type="submit">INDICAR AMIGOS AGORA</button>

                  <span class="voce-seguro">Você está seguro com a gente. Seus dados pessoais, de pagamento e contato serão
                    utilizados somente para a contratação dos serviços solicitados e para comunicação entre a Montreal e você.
                     Não compartilhamos suas informações com terceiros.</span>
                </div>

                <div class="area-sucesso">
                  <h2>
                    <img class="icon-montreal" src="assets/img/icon-sucesso-cadastro.png"/>
                    OBRIGADO
                  </h2>

                  <p><strong>Em breve, um de nossos especialistas entrará em contato com você e seu amigo indicado.</strong></p>

                  <p>Enquanto isso, que tal continuar navegando em nosso site, conhecer nossos hotéis e já começar a planejar sua próxima viagem?</p>

                  <a href="/hoteis" class="btn-verde">DESCOBRIR HOTÉIS E DESTINOS</a>
                  <a href="" class="link-verde">Indicar mais amigos</a>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="use-cupom">
    <div class="container">
      <div class="columns">
        <div class="column is-6">
          <h5>Lorem ipsum dolor sit amet, <br>consectetur adipiscing elit.</h5>  
          <p>Curabitur eu ex sed sapien mattis ullamcorper non et ante. Maecenas venenatis a ex sit amet iaculis. Nunc non imperdiet ante, non tincidunt odio. Donec auctor volutpat elit vitae iaculis. Cras euismod urna in tincidunt euismod.</p>
          <div class="cupom">
            <p>Utilize o código:</p>
            <p><strong>BLACKDAYS2020</strong></p>
            <span class="copy-text">Copiar<i class="fas fa-copy"></i></span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="entenda-como-funciona">
    <a href="" class="btn-indicar-amigos">
      <i class="fas fa-chevron-left"></i>Indicar <br>amigos
    </a>
    <div class="container">
      <div class="columns">

        <div class="column is-6">
          <h3>Entenda como funciona o Clube Montreal</h3>
          <img class="notebook-mobile" src="assets/img/notebook.png">
          <p>Nosso conceito é simples: Você paga pequenas parcelas todo mês e adquire diárias para se hospedar em qualquer hotel parceiro pelo Clube de Hospedagem. Para fazer parte, escolha a quantidade de diárias, a quantidade de pessoas e o plano que mais combina com você. Depois é só escolher seu destino, marcar sua viagem e aproveitar! Assista ao nosso vídeo e saiba mais.</p>

          <a href="" class="btn-red">CALL TO ACTION</a>
          <p> Ou baixe o aplicativo Montreal em seu celular.</p>
          <p><strong>Ainda não faz parte do Clube?</strong></p>
          <a href="" class="link-verde">Monte seu um plano</a>
        </div>
        <div class="column is-6 notebook-desktop">
          <img src="assets/img/notebook.png">
        </div>
      </div>
    </div>
  </section>

  <section id="melhor-clube-hospedagem">
    <div class="container">
      <div class="text-center">
        <h3>O melhor Clube de Hospedagem do Brasil</h3>
        <div class="columns">
          <div class="column">
            <div class="circle"></div>
            <p><strong>TAXA DE ADESÃO ZERO</strong><br>Faça parte do melhor Clube de Hospedagem sem se preocupar com Taxa de Adesão. Ela fica por nossa conta!</p>
          </div>
          <div class="column">
            <div class="circle"></div>
            <p><strong>24 MESES PARA UTILIZAR *</strong><br>Aproveite para planejar sua viagem com Tranquilidade e Conforto. Você tem até 24 meses para utilizar suas diárias.</p>
          </div>
          <div class="column">
            <div class="circle"></div>
            <p><strong>QUALIDADE EM HOSPEDAGEM</strong><br>Os melhores hotéis, no Brasil e no Mundo, você só encontra aqui. Aproveite e planeje a viagem dos seus sonhos.</p>
          </div>
          <div class="column">
            <div class="circle"></div>
            <p><strong>INDIQUE AMIGOS E GANHE DINHEIRO</strong><br>A cada amigo indicado que entrar para o Clube, você ganha o valor de uma mensalidade do Plano que ele contratou em sua conta bancária!</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="melhor-clube-hospedagem-2">
    <div class="container text-center">
      <h3>O melhor Clube de <br>Hospedagem do Brasil</h3>
      <div class="columns">
        <div class="column">
          <div class="circle"></div>
          <p><strong>TAXA DE ADESÃO ZERO</strong><br>Faça parte do melhor Clube de Hospedagem sem se preocupar com Taxa de Adesão. Ela fica por nossa conta!</p>
        </div>
        <div class="column">
          <div class="circle"></div>
          <p><strong>24 MESES PARA UTILIZAR *</strong><br>Aproveite para planejar sua viagem com Tranquilidade e Conforto. Você tem até 24 meses para utilizar suas diárias.</p>
        </div>
        <div class="column">
          <div class="circle"></div>
          <p><strong>QUALIDADE EM HOSPEDAGEM</strong><br>Os melhores hotéis, no Brasil e no Mundo, você só encontra aqui. Aproveite e planeje a viagem dos seus sonhos.</p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="circle"></div>
          <p><strong>INDIQUE AMIGOS E GANHE DINHEIRO</strong><br>A cada amigo indicado que entrar para o Clube, você ganha o valor de uma mensalidade do Plano que ele contratou em sua conta bancária!</p>
        </div>
        <div class="column">
          <div class="circle"></div>
          <p><strong>24 MESES PARA UTILIZAR *</strong><br>Aproveite para planejar sua viagem com Tranquilidade e Conforto. Você tem até 24 meses para utilizar suas diárias.</p>
        </div>
        <div class="column">
          <div class="circle"></div>
          <p><strong>QUALIDADE EM HOSPEDAGEM</strong><br>Os melhores hotéis, no Brasil e no Mundo, você só encontra aqui. Aproveite e planeje a viagem dos seus sonhos.</p>
        </div>
      </div>
    </div>
  </section>
  
  <section id="assista-video">
    <div class="container text-center">
      <div class="area-video">
        <h3>Assista ao vídeo</h3>
        <p>Curabitur eu ex sed sapien mattis ullamcorper non et ante. Maecenas venenatis a ex sit amet iaculis. Nunc non imperdiet ante, non tincidunt odio. Donec auctor volutpat elit vitae iaculis. Cras euismod urna in tincidunt euismod.</p>
        <style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><iframe src='https://www.youtube.com/embed/najT9BcOKEA' frameborder='0' allowfullscreen></iframe></div>
      </div>
    </div>
  </section>

  <section id="assista-video-2">
    <div class="container">
      <div class="columns">
        <div class="column is-6">
          <h3>Assista ao vídeo</h3>
          <p>Curabitur eu ex sed sapien mattis ullamcorper non et ante. Maecenas venenatis a ex sit amet iaculis. Nunc non imperdiet ante, non tincidunt odio. Donec auctor volutpat elit vitae iaculis. Cras euismod urna in tincidunt euismod.</p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-6">
          <style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><iframe src='https://www.youtube.com/embed/najT9BcOKEA' frameborder='0' allowfullscreen></iframe></div>
        </div>
        <div class="column is-6">
          <style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><iframe src='https://www.youtube.com/embed/najT9BcOKEA' frameborder='0' allowfullscreen></iframe></div>
        </div>
      </div>
    </div>
  </section>

  <section id="assista-video-3">
    <div class="container">
      <div class="columns">
        <div class="column is-6">
          <h3>Assista ao vídeo</h3>
          <p>Curabitur eu ex sed sapien mattis ullamcorper non et ante. Maecenas venenatis a ex sit amet iaculis. Nunc non imperdiet ante, non tincidunt odio. Donec auctor volutpat elit vitae iaculis. Cras euismod urna in tincidunt euismod.</p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><iframe src='https://www.youtube.com/embed/najT9BcOKEA' frameborder='0' allowfullscreen></iframe></div>
        </div>
        <div class="column">
          <style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><iframe src='https://www.youtube.com/embed/najT9BcOKEA' frameborder='0' allowfullscreen></iframe></div>
        </div>
        <div class="column">
          <style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><iframe src='https://www.youtube.com/embed/najT9BcOKEA' frameborder='0' allowfullscreen></iframe></div>
        </div>
      </div>
    </div>
  </section>

  <section id="montreal-hoteis" class="section">
    <div class="container is-fullhd">
      <div class="columns">
        <div class="column is-9">
          <h4 class="title">Hotéis Destaque</h4>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <div class="item-hotel medium-hotel" style="background: url(assets/img/resort-destaques.png) no-repeat center center; background-size: cover">
            <div class="overlay-img"></div>
            <div class="description-hotel">
              <h3>Ponta dos  Ganchos Resort</h3>
              <p>Governardor Celso Ramos, SC</p>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="item-hotel medium-hotel" style="background: url(assets/img/img-hotel.png) no-repeat center center; background-size: cover;">
            <div class="overlay-img"></div>
            <div class="description-hotel">
              <h3>Ponta dos  Ganchos Resort</h3>
              <p>Governardor Celso Ramos, SC</p>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="item-hotel medium-hotel" style="background: url(assets/img/img-hotel.png) no-repeat center center; background-size: cover;">
            <div class="overlay-img"></div>
            <div class="description-hotel">
              <h3>Ponta dos  Ganchos Resort</h3>
              <p>Governardor Celso Ramos, SC</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="montreal-hoteis" class="section montreal-hoteis-2">
    <div class="container is-fullhd">
      <div class="columns">
        <div class="column is-9">
          <h4 class="title">Hotéis Destaque</h4>
        </div>
      </div>

      <div class="columns">
        <div class="column is-3">
          <div class="area-hotel">
            <div class="item-hotel medium-hotel" style="background: url(assets/img/img-hotel.png) no-repeat center center; background-size: cover;">
              <div class="overlay-img"></div>
              <div class="description-hotel">
                <h3>Ponta dos  Ganchos Resort</h3>
                <p>Governardor Celso Ramos, SC</p>
              </div>
            </div>
            <p class="text-hotel">Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. </p>
          </div>
        </div>
        <div class="column is-3">
          <div class="area-hotel">
            <div class="item-hotel medium-hotel" style="background: url(assets/img/img-hotel.png) no-repeat center center; background-size: cover;">
              <div class="overlay-img"></div>
              <div class="description-hotel">
                <h3>Ponta dos  Ganchos Resort</h3>
                <p>Governardor Celso Ramos, SC</p>
              </div>
            </div>
            <p class="text-hotel">Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. </p>
          </div>
        </div>
        <div class="column is-3">
          <div class="area-hotel">
            <div class="item-hotel medium-hotel" style="background: url(assets/img/img-hotel.png) no-repeat center center; background-size: cover;">
              <div class="overlay-img"></div>
              <div class="description-hotel">
                <h3>Ponta dos  Ganchos Resort</h3>
                <p>Governardor Celso Ramos, SC</p>
              </div>
            </div>
            <p class="text-hotel">Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. </p>
          </div>
        </div>
        <div class="column is-3">
          <div class="area-hotel">
            <div class="item-hotel medium-hotel" style="background: url(assets/img/img-hotel.png) no-repeat center center; background-size: cover;">
              <div class="overlay-img"></div>
              <div class="description-hotel">
                <h3>Ponta dos  Ganchos Resort</h3>
                <p>Governardor Celso Ramos, SC</p>
              </div>
            </div>
            <p class="text-hotel">Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-tabela-diarias></app-tabela-diarias>

  <section id="montreal-faca-as-contas" class="faca-as-contas-mobile">
    <div class="container is-fullhd">
      <div class="columns">
        <div class="column is-offset-1 is-5 text-center" id="area-text-contas">
            <h1>Faça as contas</h1>
            <p><strong>Quanto custam as diárias do meu hotel no Clube Montreal?</strong><br>Pesquise hotéis e compare.</p>
        </div>
        <div class="column is-5 text-center">

          <div class="area-table-fake">

            <div class="lista-valores-head">
              <div class="item"><strong>Diárias</strong></div>
              <div class="item"><strong>Parcela</strong>/mês</div>
              <div class="item"><strong>Total</strong>/Ano</div>
            </div>

            <div class="area-select select-pessoas">
              <i class="fas fa-user-plus"></i>
              <select>
                <option value="2">2 pessoas</option>
                <option value="3">3 pessoas</option>
              </select>
            </div>

            <div class="area-select select-plano">
              <select>
                <option value="tranquilidade">Plano Tranquilidade</option>
                <option value="conforto">Plano Conforto</option>
              </select>
              <i class="fas fa-chevron-down"></i>
            </div>

            <div class="lista-valores">
              <div class="item-list">3</div>
              <div class="item-list">R$ 90,42</div>
              <div class="item-list">R$ 1.085,04</div>
            </div>
            <div class="lista-valores destaque">
              <div class="item-list">7</div>
              <div class="item-list">R$ 210,98</div>
              <div class="item-list">R$ 2.531,76</div>
            </div>
            <div class="lista-valores">
              <div class="item-list">10</div>
              <div class="item-list">R$ 301,40</div>
              <div class="item-list">R$ 3.616,80</div>
            </div>
            <div class="lista-valores">
              <div class="item-list">15</div>
              <div class="item-list">R$ 452,10</div>
              <div class="item-list">R$ 6.781,50</div>
            </div>
            <div class="lista-valores">
              <div class="item-list">20</div>
              <div class="item-list">R$ 602,80</div>
              <div class="item-list">R$ 7.233,60</div>
            </div>

          </div>
          <a class="link-call"><i class="fas fa-comment"></i> Ainda em dúvida? Fale com a gente</a>
          <br>
          <a href="" class="btn btn-primary">Monte um plano do seu jeito</a>

        </div>
      </div>
    </div>
  </section>



  <section id="montreal-depoimentos">
    <div class="container is-fullhd">
      <h3 class="text-center">O que nossos clientes falam?</h3>
      <p class="text-center">Curabitur eu ex sed sapien mattis ullamcorper non et ante. Maecenas venenatis a <br>ex sit amet iaculis. Nunc non imperdiet ante, non tincidunt odio. Donec auctor <br>volutpat elit vitae iaculis. Cras euismod urna in tincidunt euismod.</p>
      <div class="columns">
        <div class="column is-4">
          <div class="depoimento">
            <p><i>"Com parcelas pequenas, ao longo do ano, consegui pagar pela hospedagem de forma suave, além de poder
                ganhar desconto nas minhas estadias".</i></p>
            <p>
              <strong>Gaspar Ezequiel</strong>
            </p>
          </div>
        </div>
        <div class="column is-4">
          <div class="depoimento">
            <p><i>"Com parcelas pequenas, ao longo do ano, consegui pagar pela hospedagem de forma suave, além de poder
                ganhar desconto nas minhas estadias".</i></p>
            <p>
              <strong>Gaspar Ezequiel</strong>
            </p>
          </div>
        </div>
        <div class="column is-4">
          <div class="depoimento">
            <p><i>"Com parcelas pequenas, ao longo do ano, consegui pagar pela hospedagem de forma suave, além de poder
                ganhar desconto nas minhas estadias".</i></p>
            <p>
              <strong>Gaspar Ezequiel</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="montreal-depoimentos-2">
    <div class="container is-fullhd">
      <div class="columns">
        <div class="column is-6">
          <h3>O que nossos clientes falam?</h3>
          <p>Curabitur eu ex sed sapien mattis ullamcorper non et ante. Maecenas venenatis a <br>ex sit amet iaculis. Nunc non imperdiet ante, non tincidunt odio. Donec auctor <br>volutpat elit vitae iaculis. Cras euismod urna in tincidunt euismod.</p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="depoimento">
            <img src="assets/img/thumb-depoimentos.png"/>
            <p>
              <strong>Gaspar Ezequiel</strong>
            </p>
            <p><i>"Com parcelas pequenas, ao longo do ano, consegui pagar pela hospedagem de forma suave, além de poder
                ganhar desconto nas minhas estadias".</i></p>
          </div>
        </div>
        <div class="column">
          <div class="depoimento">
            <img src="assets/img/thumb-depoimentos.png"/>
            <p>
              <strong>Gaspar Ezequiel</strong>
            </p>
            <p><i>"Com parcelas pequenas, ao longo do ano, consegui pagar pela hospedagem de forma suave, além de poder
                ganhar desconto nas minhas estadias".</i></p>
          </div>
        </div>
        <div class="column">
          <div class="depoimento">
            <img src="assets/img/thumb-depoimentos.png"/>
            <p>
              <strong>Gaspar Ezequiel</strong>
            </p>
            <p><i>"Com parcelas pequenas, ao longo do ano, consegui pagar pela hospedagem de forma suave, além de poder
                ganhar desconto nas minhas estadias".</i></p>
          </div>
        </div>
        <div class="column">
          <div class="depoimento">
            <img src="assets/img/thumb-depoimentos.png"/>
            <p>
              <strong>Gaspar Ezequiel</strong>
            </p>
            <p><i>"Com parcelas pequenas, ao longo do ano, consegui pagar pela hospedagem de forma suave, além de poder
                ganhar desconto nas minhas estadias".</i></p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="destinos">

    <div class="container is-fluid">
      <div class="columns">
        <div class="column is-10">
          <h3 class="title">Destinos incríveis</h3>
          <p><strong>AS MELHORES OPORTUNIDADES PARA SE HOSPEDAR!</strong></p>
          <p>Nosso conceito é simples: Você paga pequenas parcelas fixas todo mês e adquire diárias para se hospedar em qualquer hotel contratado pela Montreal Clube de hospedagem. Para fazer parte, escolha o plano que mais combina com você, a quantidade de diárias e quantas pessoas vão viajar. Depois é só escolher seu destino, marcar sua viagem e aproveitar!</p>
        </div>
      </div>

      <div class="itens-destinos">
        <div class="tile is-ancestor">
          <div class="tile is-parent is-3">
            <article class="tile is-child notification is-success"  style="background-image: url(assets/img/hotel-bahia.png)">
              <div class="img-overlay"></div>
              <div class="footer">
                <p class="title">Salvador <small>97 hotéis</small></p>
                <p class="subtitle"><i class="fas fa-map-marker"></i> Bahia</p>
                Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet quam nae.
              </div>
            </article>
          </div>
          <div class="tile is-vertical is-3">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary" style="background-image: url(assets/img/hotel-fortaleza.png)">
                  <div class="img-overlay"></div>
                  <div class="footer">
                    <p class="title">Salvador <small>97 hotéis</small></p>
                    <p class="subtitle"><i class="fas fa-map-marker"></i> Bahia</p>
                    Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet quam nae.
                  </div>
                </article>
                <article class="tile is-child notification is-primary" style="background-image: url(assets/img/hotel-fortaleza.png)">
                  <div class="img-overlay"></div>
                  <div class="footer">
                    <p class="title">Salvador <small>97 hotéis</small></p>
                    <p class="subtitle"><i class="fas fa-map-marker"></i> Bahia</p>
                    Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet quam nae.
                  </div>
                </article>
              </div>
            </div>
          </div>
          <div class="tile is-parent is-3">
            <article class="tile is-child notification is-success"  style="background-image: url(assets/img/hotel-bahia.png)">
              <div class="img-overlay"></div>
              <div class="footer">
                <p class="title">Salvador <small>97 hotéis</small></p>
                <p class="subtitle"><i class="fas fa-map-marker"></i> Bahia</p>
                Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet quam nae.
              </div>
            </article>
          </div>
          <div class="tile is-vertical is-3">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary" style="background-image: url(assets/img/hotel-fortaleza.png)">
                  <div class="img-overlay"></div>
                  <div class="footer">
                    <p class="title">Salvador <small>97 hotéis</small></p>
                    <p class="subtitle"><i class="fas fa-map-marker"></i> Bahia</p>
                    Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet quam nae.
                  </div>
                </article>
                <article class="tile is-child notification is-primary" style="background-image: url(assets/img/hotel-fortaleza.png)">
                  <div class="img-overlay"></div>
                  <div class="footer">
                    <p class="title">Salvador <small>97 hotéis</small></p>
                    <p class="subtitle"><i class="fas fa-map-marker"></i> Bahia</p>
                    Lorem ipsum dolor sit amet consect etuer adispisng elit quam nae. Lorem ipsum dolor sit amet quam nae.
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>

  <section id="regulamento">
    <div class="container">
      <h3>Regulamento da Promoção</h3>
      <div class="columns">
        <div class="column is-4">
          <div class="importante-saber">
            <h5>O que é importante saber?</h5>

            <p><i class="fas fa-check"></i>Promoção válida até 27/06/2020.

            <p><i class="fas fa-check"></i>Você pode indicar até seis pessoas.</p>

            <p><i class="fas fa-check"></i>Serão contabilizados apenas indicações que gerarem contratação de planos.</p>

            <p><i class="fas fa-check"></i>Você não precisa ser cliente para participar.</p>

            <p><i class="fas fa-check"></i>Lorem ipsum dolor sit amet.</p>
          </div>
        </div>

        <div class="column is-8">
          <h5>Promo Lorem Ipsum</h5>
          <p>Curabitur eu ex sed sapien mattis ullamcorper non et ante. Maecenas venenatis a ex sit amet iaculis. Nunc non imperdiet ante, non tincidunt odio. Donec auctor volutpat elit vitae iaculis. Cras euismod urna in tincidunt euismod. </p>

          <p>Curabitur eu ex sed sapien mattis ullamcorper non et ante. Maecenas venenatis a ex sit amet iaculis. Nunc non imperdiet ante, non tincidunt odio. Donec auctor volutpat elit vitae iaculis.</p>

          <h5>Regulamento da promoção</h5>

          <div class="area-pdf">
            <a href="">
              <i class="fas fa-file-download"></i>
              <i class="far fa-external-link-alt"></i>
              <p><strong>Promo Dia das Mães</strong></p>
              <p>Download do regulamento <br>completo em PDF.</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="como-funciona-clube-montreal">
    <div class="container">
      <div class="columns">
         <div class="column is-6">
          <h3>Entenda como funciona o Clube Montreal</h3>
          <p>Nosso conceito é simples: Você paga pequenas parcelas todo mês e adquire diárias para se hospedar em qualquer hotel parceiro pelo Clube de Hospedagem. Para fazer parte, escolha a quantidade de diárias, a quantidade de pessoas e o plano que mais combina com você. Depois é só escolher seu destino, marcar sua viagem e aproveitar! Assista ao nosso vídeo e saiba mais.</p>

          <a href="" class="btn-red">CALL TO ACTION</a>
          <p> Ou baixe o aplicativo Montreal em seu celular.</p>
          <p><strong>Ainda não faz parte do Clube?</strong></p>
          <a href="" class="link-verde">Monte seu um plano</a>
        </div>
        <div class="column is-6 text-center">
          <img src="assets/img/economia-nas-diarias.png">
        </div>
      </div>
    </div>
  </section>


  <app-footer></app-footer>

</div>
